import {
  ActivatedRouteSnapshot,
  ResolveFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { inject } from '@angular/core';
import { from, Observable, of, switchMap, take } from 'rxjs';
import { Workshop } from './workshop.model';
import { WorkshopService } from './workshop.service';

export const resolveWorkshop: ResolveFn<Workshop | undefined> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  workshopService: WorkshopService = inject(WorkshopService),
  router: Router = inject(Router),
): Observable<Workshop> => {
  const slug = route.paramMap.get('slug');
  if (!slug) {
    return from(router.navigate(['/404'])) as Observable<never>;
  }
  return workshopService.findOneBySlug(slug).pipe(
    switchMap((workshop) =>
      workshop
        ? of(workshop)
        : (from(router.navigate(['/404'])) as Observable<never>),
    ),
    take(1),
  );
};
